import store from '@/store/index.js'
// 包路径
const package_NdefRecord = 'android.nfc.NdefRecord';
const package_NdefMessage = 'android.nfc.NdefMessage';
const package_TECH_DISCOVERED = 'android.nfc.action.TECH_DISCOVERED';
const package_Intent = 'android.content.Intent';
const package_Activity = 'android.app.Activity';
const package_PendingIntent = 'android.app.PendingIntent';
const package_IntentFilter = 'android.content.IntentFilter';
const package_NfcAdapter = 'android.nfc.NfcAdapter';
const package_Ndef = 'android.nfc.tech.Ndef';
const package_NdefFormatable = 'android.nfc.tech.NdefFormatable';
const package_Parcelable = 'android.os.Parcelable';
const package_String = 'java.lang.String';

let NfcAdapter;
let NdefRecord;
let NdefMessage;
let Uri;
let readyWriteData = false;
let readyRead = false;
let noNFC = false;
let techListsArray = [
  ['android.nfc.tech.IsoDep'],
  ['android.nfc.tech.NfcA'],
  ['android.nfc.tech.NfcB'],
  ['android.nfc.tech.NfcF'],
  ['android.nfc.tech.Nfcf'],
  ['android.nfc.tech.NfcV'],
  ['android.net.Uri'],
  ['android.nfc.tech.NdefFormatable'],
  ['android.nfc.tech.MifareClassi'],
  ['android.nfc.tech.MifareUltralight']
];
// 要写入的数据
let text = 'https://baidu.com';
let readResult = '';
let success = ''
let id = ''
let chipUid = ''
let multipleWrite = false
let isNFCInitialized = false;

export default {

  listenNFCStatus: function() {
    if (typeof plus === 'undefined') {
      console.log('不在 UniApp 环境中，跳过 NFC 初始化');
      return;
    }


    if (isNFCInitialized) {
      console.log('NFC 已经初始化，无需重复执行');
      return;
    }

    let that = this;
    try {
      let main = plus.android.runtimeMainActivity();
      let Intent = plus.android.importClass('android.content.Intent');
      let Activity = plus.android.importClass('android.app.Activity');
      let PendingIntent = plus.android.importClass('android.app.PendingIntent');
      let IntentFilter = plus.android.importClass('android.content.IntentFilter');
      Uri = plus.android.importClass('android.net.Uri');
      NfcAdapter = plus.android.importClass('android.nfc.NfcAdapter');
      let nfcAdapter = NfcAdapter.getDefaultAdapter(main);

      if (nfcAdapter == null) {
        alert('设备不支持NFC！');
        // uni.showToast({
        //   title: '设备不支持NFC！',
        //   icon: 'none'
        // })
        noNFC = true;
        return;
      }

      if (!nfcAdapter.isEnabled()) {
        // uni.showToast({
        //   title: '请在系统设置中先启用NFC功能！',
        //   icon: 'none'
        // });
        alert('请在系统设置中先启用NFC功能！');
        noNFC = true;
        return;
      } else {
        noNFC = false;
      }

      let intent = new Intent(main, main.getClass());
      intent.addFlags(Intent.FLAG_ACTIVITY_SINGLE_TOP);
      let pendingIntent = PendingIntent.getActivity(main, 0, intent, 0);
      let ndef = new IntentFilter("android.nfc.action.TECH_DISCOVERED");
      ndef.addDataType("*/*");
      let intentFiltersArray = [ndef];

      document.addEventListener('newintent', function() {
        console.log('处理NFC监听消息');
        // 监听 NFC
        setTimeout(() => that.nfcRunning(), 100);
      });
      document.addEventListener('pause', function(e) {
        console.log('暂停监听...');
        if (nfcAdapter) {
          //关闭前台调度系统
          //恢复默认状态
          nfcAdapter.disableForegroundDispatch(main);
        }
      });
      document.addEventListener('resume', function(e) {
        console.log('恢复监听...');
        if (nfcAdapter) {
          //开启前台调度系统
          nfcAdapter.enableForegroundDispatch(main, pendingIntent, intentFiltersArray, techListsArray);
        }
      });
      nfcAdapter.enableForegroundDispatch(main, pendingIntent, intentFiltersArray, techListsArray);
      this.enableReadData()
      isNFCInitialized = true;
    } catch (e) {
      console.error(e);
    }
  },
  random32bit() {
    let u = new Uint32Array(1);
    window.crypto.getRandomValues(u);
    let str = u[0].toString(16).toUpperCase();
    return '00000000'.slice(str.length) + str;
  },
  nfcRunning: function() {
    NdefRecord = plus.android.importClass("android.nfc.NdefRecord");
    NdefMessage = plus.android.importClass("android.nfc.NdefMessage");
    let main = plus.android.runtimeMainActivity();
    let intent = main.getIntent();
    let that = this;
    let bytesId = intent.getByteArrayExtra(NfcAdapter.EXTRA_ID);
    chipUid = that.byteArrayToHexString(bytesId);

    store.commit('setLastChipUid', chipUid)
    console.log('setLastChipUid:', chipUid);
    id = chipUid

    if (package_TECH_DISCOVERED == intent.getAction()) {
      if (readyWriteData) {
        that.write(intent);
        readyWriteData = false;
      } else if (readyRead) {
        that.read(intent, chipUid);
        readyRead = false;
      }
    }
  },
  write(intent) {
    try {
      toast('请勿移开标签 正在写入...');
      let that = this;

      let randomCode = Math.floor(1 + Math.random() * 100000000);
      //var writeURL = "https://www.eforall.cn/ttsH5/#/salesDetails?id=" + id + '&code=' + randomCode ;
      //检查 text ,如果没有 code 参数,则附加  '&code=' + randomCode

      // 检查 text 是否已经包含 'code=' 参数
      if (!text.includes("chipCode=")) {
        // 如果没有 code 参数，则附加上 code 参数
        if (text.includes("?")) {
          text += '&chipCode=' + randomCode;
        } else {
          text += '?chipCode=' + randomCode;
        }
      }

      // 检查 text 是否为有效的 URI
      console.log("text=" + text);
      let uri = Uri.parse(text);
      if (uri == null) {
        toast('无效的URI');
        return;
      }


      // 输出修改后的 URI
      console.log("处理后的 URI=" + uri.toString());

      // 创建 NdefMessage
      let message = new NdefMessage([new NdefRecord.createUri(uri)]);
      console.log("=write ===message===>", JSON.stringify(message));

      let Ndef = plus.android.importClass('android.nfc.tech.Ndef');
      let NdefFormatable = plus.android.importClass('android.nfc.tech.NdefFormatable');

      // 从 intent 中获取 NFC 标签（tag）
      let tag = intent.getParcelableExtra(NfcAdapter.EXTRA_TAG);
      if (tag == null) {
        toast('无法获取 NFC 标签');
        return;
      }

      let ndef = Ndef.get(tag);
      console.log("===write ndef:", JSON.stringify(ndef));

      if (ndef != null) {
        // 待写入的数据长度
        let size = message.toByteArray().length;

        // 连接标签
        ndef.connect();
        if (!ndef.isWritable()) {
          toast('tag不允许写入！');
          return;
        }

        // 检查标签容量
        if (ndef.getMaxSize() < size) {
          toast('文件大小超出容量！');
          return;
        }

        // 写入 NDEF 消息
        ndef.writeNdefMessage(message);

        // 获取 chipUid
        let bytesId = intent.getByteArrayExtra(NfcAdapter.EXTRA_ID);
        let chipUid = that.byteArrayToHexString(bytesId); // 确保这个方法存在
        if (!chipUid) {
          toast('无法获取chipUid');
          return;
        }

        let link = `${text}&chipUid=${chipUid}&variation=${that.random32bit()}`;
        console.log('跳转link ', link);

        // 成功提示并记录写入信息
        toast('写入数据成功！');
        store.commit('setNfcWriteTxt', link);

        success = 'ok';
        return;

      } else {
        // 尝试格式化 NDEF 标签并写入
        let format = NdefFormatable.get(tag);
        if (format != null) {
          try {
            format.connect();
            format.format(message);
            toast('格式化tag并且写入message');
            return;
          } catch (e) {
            toast('格式化tag失败.');
            console.log('format error: ', JSON.stringify(e));
            return;
          }
        } else {
          toast('Tag不支持NDEF');
          return;
        }
      }
    } catch (e) {
      toast('写入失败');
      console.log("error:" + JSON.stringify(e));
    }
  },
  read(intent, chipUid) {
    try {
      console.log(`----开始读取芯片${chipUid}消息`)
      let that = this;
      //let Parcelable = plus.android.importClass("android.os.Parcelable");
      let rawMessages = intent.getParcelableArrayExtra("android.nfc.extra.NDEF_MESSAGES");
      //let rawMessages = intent.getParcelableArrayExtra();

      if (rawMessages != null && rawMessages.length > 0) {
        let records = rawMessages[0].getRecords();
        let result = records[0].getPayload();
        let data = plus.android.newObject("java.lang.String", result);
        console.log('读取到 NFC 数据：', data);
        if (data) {
          let url = data;
          let toURL = ''; // 初始化最终 URL
          let basePath = '#'; // 需要查找的 basePath eforall.cn/ttsH5/#
          let baseIndex = url.indexOf(basePath); // 查找 basePath 在 newUrl 中的起始位置
          let path = ''; // 初始化 path

          if (baseIndex !== -1) {
            path = url.substring(baseIndex + basePath.length);
            toURL = path + '&chipUid=' + chipUid + '&variation=' + that.random32bit();
            store.commit('setNfcReadTxt', toURL);
            console.log('--------read URL 处理完成')
          } else {
            let scheme = 'tatashi://';
            let schemeIndex = url.indexOf(scheme); // 查找 scheme 在 url 中的起始位置

            if (schemeIndex !== -1) {
              // 如果找到了 scheme，则处理该 URL
              let schemeEndIndex = schemeIndex + scheme.length; // 计算 scheme 结束位置
              path = url.substring(schemeEndIndex); // 提取 scheme 后的路径
              toURL = path + '&chipUid=' + chipUid + '&variation=' + that.random32bit();
              store.commit('setNfcReadTxt', toURL);
              console.log('--------read scheme 处理完成')
            } else {
              // 如果都匹配不到
              store.commit('setNfcReadTxt', url + '/chipUid=' + chipUid + '&variation=' + that.random32bit());
              console.log('--------read 其它情况 处理完成')
            }
          }
          readResult = data;
        }
      } else {
        toast('未读取到有效数据,只有用小掌写入数据后的芯片才能读取相关信息哦!');
        setTimeout(() => {
          this.enableReadData()
        }, 1500)
      }
    } catch (e) {
      //TODO handle the exception
    }
  },
  byteArrayToHexString: function(inarray) { // converts byte arrays to string
    let i, j, inn;
    let hex = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
    let out = "";

    for (j = 0; j < inarray.length; ++j) {
      inn = inarray[j] & 0xff;
      i = (inn >>> 4) & 0x0f;
      out += hex[i];
      i = inn & 0x0f;
      out += hex[i];
    }
    return out;
  },
  writeData: function(url) {
    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    readyWriteData = true;
    toast('请将NFC标签靠近！');
    text = url;
    return id
  },

  multipleWriteData: function (url) {
    multipleWrite = true
    this.writeData(url)
  },

  //新增的方法 写入并跳转
  writeDataAndJump: function(url) {

    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    readyWriteData = true;
    toast('请将NFC标签靠近！');
    text = url;
    //返回写入成功
    while (resStatus === 'ok') {
      return 'ok';
    }

  },
  readData: function() {
    if (typeof plus === 'undefined') {
      console.log('不在 UniApp 环境中，跳过');
      return;
    }

    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    readyRead = true;
    console.log("readData 已设置readyRead为true...开始下一步读取....")
  },
  enableReadData: function() {
    if (typeof plus === 'undefined') {
      console.log('不在 UniApp 环境中，跳过');
      return;
    }

    if (noNFC) {
      toast('请检查设备是否支持并开启 NFC 功能！');
      return;
    }
    // 监听事件，触发条件
    readyRead = true;
    console.log("----enableReadData 恢复 NFC 处理读取的消息")
  },

  // 输入文本改变
  inputChanage: function(res) {
    console.log("正在编辑写入数据...", res)
    text = res
  },
  setReadDataFalse: function() {
    // 轮询条件
    readyRead = false;
  },
  setReadDataTrue: function() {
    // 轮询条件
    readyRead = true;
  }
}

function toast(content) {
  // uni.showToast({
  // 	title: content,
  // 	icon: 'none'
  // })
  alert(content);
}



// WEBPACK FOOTER //
// ./src/utils/nfc.js